<template>
<div class="index_content">
    <div class="content" :style="{backgroundImage: `url(${image})`}">
        <navTop></navTop>
        <div class="center_main">
            <div class="content-main">
                <div class="left-main">
                    <div class="left-main-content">

                        <div class="title mgt60"><span class="colorFB092B">关于</span><span>我们</span></div>
                        <div class="title-btnsList">
                            <div class="sec-title">ABOUT<br>
                                US</div>
                            <div class="btnsList">
                                <div :class="{'btn-child':true,'active-btn':item.isClick}" v-for="item in btnList" :key="item.text" @click="changeBtn(item)">{{item.text}}</div>
                            </div>
                        </div>
                        <div class="left-main-box">
                            <div v-for="(item,index) in btnList" :key="index" class="main-content" v-if="item.isClick">
                                <div v-if="item.id==0&&item.isClick" class="about-box">
                                    <div class="left-box"></div>
                                    <div class="right-content">
                                        <div class="right-box">
                                            <div class="title">资阳跨境贸易单一窗口综合服务平台</div>
                                            <div class="text">资阳商务局主要拟订全市国内外贸易、外商投资和对外经济合作的相关政策、规范性文件和实施细则，制定全市商务发展规划、年度计划并组织实施。</div>
                                            <div class="text mgt40">
                                                主要职责:<br>
                                                一、贯彻落实国家、省有关国内外贸易、国际经济合作的方针、政策和法律、法规、规章，拟订全市国内外贸易、对外经济合作的相关政策、规范性文件和实施细则，制定全市商务发展规划、年度计划并组织实施。

                                                二、按要求承担商贸服务业发展工作中组织实施的协调职责，推进流通产业结构调整，加快第三方物流发展，指导流通企业改革、商贸服务业和社区商业发展，提出促进商贸企业发展的政策建议，推动流通标准化和连锁经营、商业特许经营、物流配送、电子商务等现代流通方式的发展。

                                                三、拟订市场体系建设的规划和支持政策，组织编制大宗商品批发市场规划，指导城市商业网点规划、网点布局管理和商业体系建设工作，推进农村市场体系建设，组织实施农村现代流通网络工程，促进城乡市场一体化发展。

                                                四、拟订规范市场运行和流通秩序的政策，推动商务领域信用体系建设，指导商业企业开展信用销售，规范促销行为，建立市场诚信公共服务平台，按有关规定对特殊流通行业和酒类流通行业进行监督管理，承担茧丝绸协调工作，依法打击商业欺诈行为。

                                                五、承担组织实施重要消费品市场调控和重要生产资料流通管理的责任，负责建立健全生活必需品市场供应应急管理机制，监测分析市场运行、商品供求状况，调查分析商品价格信息，进行预测预警和信息引导，按分工负责重要消费品储备管理和市场调控工作。

                                                六、指导对外贸易行业执行国家进出口商品、加工贸易管理办法和进出口管理商品、技术目录，组织实施重要工业品、原材料和重要农产品进出口总量计划，会同有关部门协调大宗进出口商品和出口加工区的业务工作，指导贸易促进活动和外贸促进体系建设。

                                                七、依法监督技术引进、设备进口、国家限制出口技术的工作，推进进出口贸易标准化工作，牵头负责发展服务贸易的相关工作，推动服务外包平台建设。

                                                八、拟订应对经济全球化、区域经济合作的对策措施，加强与自由贸易区、港澳台地区的商贸合作，推进贸易和投资便利化。

                                                九、承担组织协调反倾销、反补贴、保障措施和技术性贸易壁垒等与进出口公平贸易相关工作的责任，建立进出口公平贸易预警机制，牵头开展对外贸易调查、产业损害调查和对经营者集中行为的反垄断审查，指导协调产业安全应对、企业在国外的反垄断应诉工作和国外对我市出口商品的反倾销、反补贴、保障措施的应诉工作。

                                                十、负责全市对外经济合作工作，拟订并执行对外经济合作政策，依法管理和监督对外承包工程、对外劳务合作和出境就业等，承担境外投资管理的责任，牵头负责外派劳务和赴境外就业人员的权益保护工作，执行我市的国家对外援助任务，管理多双边对我市的无偿援助和赠款（不含财政合作项目下外国政府及国际金融组织对我市赠款）等发展合作业务。

                                                十一、管理我市赴境外举办的各种商品交易会和经贸推介活动，指导监督管理以资阳市名义在境内举办的各种商贸交易会、展览会、展销会等活动。

                                                十二、规划全市商务系统电子政务、公共商务信息服务体系建设并组织实施，推动信息网络建设和电子商务发展。

                                                十三、承担市政府公布的有关行政审批、行政许可事项。

                                                十四、承担全市服务业发展工作中组织实施的协调工作。

                                                十五、承办市政府交办的其他事项。
                                            </div>
                                        </div>

                                    </div>

                                </div>
                                <div v-if="item.id==1&&item.isClick" class="call-box">
                                    <div class="call-top">
                                        <div class="call-top-left">
                                            <div class="call-top-title">资阳跨境贸易单一窗口综合服务平台</div>
                                            <div class="call-top-text">联系电话：028-8335-5593</div>
                                            <div class="call-top-text">公司网址：www.scitcs.com</div>
                                            <div class="call-top-text">公司地址：四川省成都市武侯区桂溪街道城区天泰路112号北楼1501</div>
                                            <div class="call-top-qr">
                                                <img src="../assets/images/qrcode.jpg" alt="" width="100%" height="100%">
                                            </div>
                                        </div>
                                        <div class="call-top-right">
                                            <el-amap :amap-manager="amapManager" :vid="'amap-vue'" :zoom="zoom" :center="center">
                                                <!-- 标记 -->
                                                <el-amap-marker v-for="(marker, index) in markers" :position="marker" :key="index"></el-amap-marker>
                                            </el-amap>
                                        </div>
                                    </div>
                                    <div class="call-bottom">
                                        <div class="people-box">
                                            <img src="../assets/images/about_icon.png" alt="" width="116px" height="116px">
                                            <div class="">
                                                <div class="name">居平河</div>
                                                <div class="post">业务经理</div>
                                                <div class="contact-info">13608096674（微信同号）</div>
                                            </div>
                                        </div>
                                        <div class="people-box">
                                            <img src="../assets/images/about_icon.png" alt="" width="116px" height="116px">
                                            <div class="">
                                                <div class="name">居平河</div>
                                                <div class="post">业务经理</div>
                                                <div class="contact-info">13608096674（微信同号）</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

</div>
</template>

<script>
import top_active from "../assets/images/top_active.png"
import top_default from "../assets/images/top_default.png"
import navTop from '@/components/navTop'
import {ossUrl} from "@/utils/config"

import {
    AMapManager,
    lazyAMapApiLoaderInstance
} from "vue-amap";
let amapManager = new AMapManager();
export default {
    name: "servesProduct",
    components: {
        navTop
    },
    watch: {
        "vdata"(newvalue) {
            //console.log(newvalue, "2____________")
        }
    },
    data() {
        return {
             ossUrl:ossUrl,
            amapManager,
            markers: [],
            center: [104.07274727, 30.57899372],
            zoom: 16,
            lng: 0,
            lat: 0,
            list: [],
            image: "",
            default_icon: top_default,
            active_icon: top_active,
            loaded: false,
            btnList: [{
                id: 0,
                text: "关于我们",
                isClick: true,
            }, {
                id: 1,
                text: "联系我们",
                isClick: false
            }],
            events: {
                init() {
                    lazyAMapApiLoaderInstance.load().then(() => {
                        self.initSearch();
                    });
                },
                // 点击获取地址的数据
                click(e) {
                    self.markers = [];
                    let {
                        lng,
                        lat
                    } = e.lnglat;
                    self.lng = lng;
                    self.lat = lat;
                    self.center = [lng, lat];
                    self.markers.push([lng, lat]);
                    // 这里通过高德 SDK 完成。
                    let geocoder = new AMap.Geocoder({
                        radius: 1000,
                        extensions: "all"
                    });
                    geocoder.getAddress([lng, lat], function (status, result) {
                        if (status === "complete" && result.info === "OK") {
                            if (result && result.regeocode) {
                                self.address = result.regeocode.formattedAddress;
                                self.searchKey = result.regeocode.formattedAddress;
                                self.$emit("updateLocation", lng, lat, self.searchKey);
                                self.$nextTick();
                            }
                        }
                    });
                }
            },
            // 一些工具插件
            plugin: [{
                // 定位
                pName: "Geolocation",
                events: {
                    init(o) {
                        // o是高德地图定位插件实例
                        o.getCurrentPosition((status, result) => {
                            if (result && result.position) {
                                if (self.isEdit) {
                                    // 设置经度
                                    self.lng = self.longitude;
                                    // 设置维度
                                    self.lat = self.latitude;
                                    // 设置坐标
                                    self.center = [self.longitude, self.latitude];
                                    self.markers.push([self.longitude, self.latitude]);
                                } else {
                                    // 设置经度
                                    self.lng = result.position.lng;
                                    // 设置维度
                                    self.lat = result.position.lat;
                                    // 设置坐标
                                    self.center = [self.lng, self.lat];
                                    self.markers.push([self.lng, self.lat]);
                                }
                                // load
                                self.loaded = true;
                                // 页面渲染好后
                                self.$nextTick();
                            }
                        });
                    }
                }
            }]
        }
    },
    methods: {
        changeBtn(tem) {
            this.btnList.forEach((item, index) => {
                //console.log()
                if (item.id == tem.id) {
                    this.$set(this.btnList, index, {
                        id: item.id,
                        text: item.text,
                        isClick: true,
                    })
                } else {
                    this.$set(this.btnList, index, {
                        id: item.id,
                        text: item.text,
                        isClick: false,
                    })
                }
            })
            //console.log(this.btnList)
        },
        getTagDAta(data) {
            //this.isShow=true;
            //console.log(data, "2_______22222")
            this.changeTag(data.item, data.index)
            // this.bottomList=data;
            // this.isShow=true;
            //window.location.reload();
        },
        getBg(path) {
            if (path == '/aboutUs') {
                this.image = `${this.ossUrl}/bg_11.png`;
            }
        },
        changeTag(item, index) {
            //console.log(item, index);
            //console.log(index % 2)
            this.bottomList.forEach((item, num) => {
                if (index == num) {

                    this.$set(this.bottomList, num, {
                        id: item.id,
                        text: item.text,
                        isText: item.isText,
                        isShow: item.isShow,
                        hasClass: true,
                    })
                } else {
                    this.$set(this.bottomList, num, {
                        id: item.id,
                        text: item.text,
                        isText: item.isText,
                        isShow: item.isShow,
                        hasClass: false,
                    })
                }
                if (index % 2 == 0 && index == num) {
                    this.activeTag = item.id;

                    //console.log(this.activeTag,"activeTag")
                    this.$set(this.bottomList, num + 1, {
                        id: item.id,
                        text: "",
                        isText: false,
                        isShow: false,
                    })
                } else {

                    //console.log(num, num + 1, this.bottomList.length)
                    if (num % 2 == 0 && num + 1 < 11) {
                        this.$set(this.bottomList, num + 1, {
                            id: item.id,
                            text: "",
                            isText: false,
                            isShow: true
                        })
                    }

                }
            })
            if (index == 10) {
                //console.log(1111111)
                this.$set(this.bottomList, 9, {
                    id: item.id,
                    text: "",
                    isText: false,
                    isShow: false
                })
            }
        }
    },
    created() {
        console.log(this.$route);
        this.getBg(this.$route.path);
        this.$set(this.bottomList, 1, {
            id: 1,
            text: "",
            isText: false,
            isShow: false,
            hasClass: false,
        });
        //console.log(this.bottomList)

    }
}
</script>

<style lang="less" scoped>
.index_content {
    width: 100%;
    height: 100%;
    background-color: #06162F;
}

.center_main {
    display: flex;
    flex: 1;
    flex-direction: column;
    //border: 1px red solid;
}

.content {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    background-size: cover;
    background-repeat: no-repeat;
    overflow: hidden;
    background-position: center center;

}

.center_main_bottom {
    //width: 100%;
    height: 20%;
    min-height: 150px !important;
    background: rgba(2, 21, 39, 0.35);
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding: 0 240px;

    //border:1px red solid;
    .item {
        //border: 1px red solid;
        height: 116.5%;
        //color: white;
        //padding:0 60px;
        display: flex;
        min-width: 150px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 28px;
        margin-top: -3%;
    }

    .item_icon {
        width: 15px;
        height: 80%;
        margin: 10px;
        background-image: url("../assets/images/icon_2.png");
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center center;
    }
}

.center_main_top {
    width: 100%;
    height: 80%;

    .tag_main {
        width: 100%;
        height: 100%;
        //border: 1px green solid;
    }
}

.active_tag {
    background: linear-gradient(180deg, rgba(54, 169, 255, 0.35) 0%, rgba(54, 169, 255, 0.1) 100%);
    border-top: 5px #36A9FF solid;
}

.content-main {
    //background-color: yellowgreen;
    width: 100%;
    //height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    .left-main {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;

        .left-main-content {
            width: 1440px;
            height: 100%;
            display: flex;
            flex-direction: column;
            //align-items: center;
        }

        .left-main-box {
            display: flex;
            flex: 1;
            justify-content: space-between;
            align-items: center;
            //border: 1px red solid;
            width: 100%;
            margin-top: 80px;

            .main-content {
                width: 100%;
                height: 100%;
                //border:1px red solid;
                display: flex;

                .about-box,
                .call-box {
                    display: flex;
                    flex: 1;
                    //border:1px red solid;

                }

                .about-box {
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    .right-content {
                        width: 60%;
                        height: 100%;
                        position: relative;
                        //border: 1px red solid;

                        .right-box {
                            // width: 100%;
                            height: 332px;
                            padding-left: 127px;
                            padding-top: 51px;
                            padding-right: 183px;
                            padding-bottom: 109px;
                            overflow-y: scroll;
                            overflow-x: auto;

                            background: linear-gradient(135deg, #CC1F37 0%, rgba(152, 0, 35, 0) 100%);

                            .title {
                                font-size: 30px;
                                font-family: PingFangSC-Medium, PingFang SC;
                                font-weight: 500;
                                color: #FFFFFF;
                                line-height: 42px;
                                margin-bottom: 40px;
                            }

                            .text {
                                font-size: 16px;
                                font-family: PingFangSC-Regular, PingFang SC;
                                font-weight: 400;
                                color: #FFFFFF;
                                line-height: 30px;
                            }

                            .innerbox::-webkit-scrollbar {
                                /*滚动条整体样式*/
                                width: 4px;
                                /*高宽分别对应横竖滚动条的尺寸*/

                                height: 4px;

                            }

                            .innerbox::-webkit-scrollbar-thumb {
                                /*滚动条里面小方块*/

                                border-radius: 5px;

                                -webkit-box-shadow: inset005pxrgba(0, 0, 0, 0.2);

                                background: rgba(0, 0, 0, 0.2);

                            }

                            .innerbox::-webkit-scrollbar-track {
                                /*滚动条里面轨道*/

                                -webkit-box-shadow: inset005pxrgba(0, 0, 0, 0.2);

                                border-radius: 0;

                                background: rgba(0, 0, 0, 0.1);

                            }
                        }
                    }

                    .right-content::after {
                        position: absolute;
                        content: "";
                        top: 38px;
                        left: -66px;
                        border-top: 74px solid transparent;
                        border-bottom: 67px solid transparent;
                        border-right: 66px solid #CC1F37;
                        transform: skewY(-50deg);
                        //border: 1px red solid;
                        z-index: 999;
                    }

                    .left-box {
                        width: 40%;
                        min-width: 500px;
                        height: 500px;
                        display: flex;
                        justify-content: flex-end;
                        align-items: center;
                        background-image: url("../assets/images/about_icon.png");
                        background-position: center center;
                        background-size: contain;
                        background-repeat: no-repeat;

                    }

                }

                .call-box {
                    height: 75%;
                    margin-top: 20px;
                    padding-top: 50px;
                    padding-bottom: 50px;
                    padding-left: 40px;
                    padding-right: 40px;
                    background: linear-gradient(135deg, #CC1F37 0%, rgba(152, 0, 35, 0) 100%);
                    flex-direction: column;

                    .call-top {
                        width: 100%;
                        height: 60%;
                        border-bottom: 1px rgba(255, 255, 255, 0.24) solid;
                        display: flex;
                        justify-content: space-between;
                        align-items: flex-start;
                        padding-bottom: 30px;

                        .call-top-left {
                            .call-top-title {
                                font-size: 30px;
                                font-family: PingFangSC-Semibold, PingFang SC;
                                font-weight: 600;
                                color: #FFFFFF;
                                line-height: 42px;
                                margin-bottom: 6px;
                            }

                            .call-top-text {
                                font-size: 16px;
                                font-family: PingFangSC-Regular, PingFang SC;
                                font-weight: 400;
                                color: #FFFFFF;
                                line-height: 30px;
                                margin-bottom: 5px;
                            }

                            .call-top-qr {
                                width: 120px;
                                height: 120px;
                                border: 1px #fff solid;
                            }
                        }

                        .call-top-right {
                            width: 477px;
                            height: 260px;
                            border: 1px #ccc solid;
                        }
                    }

                    .call-bottom {
                        width: 100%;
                        height: 40%;
                        margin-top: 30px;
                        display: flex;
                        justify-content: space-between;
                        align-items: flex-start;

                        .people-box {
                            width: 43%;
                            height: 116px;
                            padding: 32px 42px;
                            //border:1px red solid;
                            background: linear-gradient(135deg, #FFFFFF 0%, #FFFFFF 100%);
                            border-radius: 0px 16px 0px 16px;
                            display: flex;
                            justify-content: flex-start;
                            align-items: center;

                            .name {
                                font-size: 24px;
                                font-family: PingFangSC-Medium, PingFang SC;
                                font-weight: 500;
                                color: #000000;
                                line-height: 30px;
                            }

                            .post {
                                font-size: 16px;
                                font-family: PingFangSC-Regular, PingFang SC;
                                font-weight: 400;
                                color: #333333;
                                line-height: 30px;
                            }

                            .contact-info {
                                font-size: 16px;
                                font-family: PingFangSC-Regular, PingFang SC;
                                font-weight: 400;
                                color: #333333;
                            }

                            img {
                                margin-right: 30px;
                            }
                        }

                    }
                }
            }
        }
    }

    .right-main {
        width: 15%;
        height: 100%;
        padding-right: 60px;

        //background-color: rgb(167, 164, 164);
        display: flex;
        justify-content: flex-end;
        align-items: center;

        .tagLabel-box {
            width: 40px;
            height: 100%;
            //margin-top: 160px;
            //border: 1px red solid;
            display: flex;
            justify-content: space-around;
            align-items: center;
            flex-direction: column;

            .label-top {
                width: 100%;
                height: 30%;
                display: flex;
                justify-content: space-around;
                align-items: center;
                flex-direction: column;

                //border: 1px green solid;

                .icon-item {
                    width: 8px;
                    height: 8px;
                    background-size: contain;
                    background-position: center center;
                }
            }

            .label-bottom {
                width: 100%;
                height: 30%;
                //border: 1px green solid;

                .label-bottom-top {
                    width: 100%;
                    height: 80%;
                    //border: 1px red solid;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    flex-direction: column;
                }

                .label-bottom-bottom {
                    width: 100%;
                    height: 30%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    //border:1px red solid;
                }
            }
        }
    }
}

.colorFB092B {
    color: #FB092B;
}

.active-top {
    height: 120px !important;
    color: white !important;
    //background-color: red;
    //margin-bottom: 20px !important;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    padding: 5px 24px;
}

.title {

    font-size: 60px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
    line-height: 84px;
}

.sec-title {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.85);
    line-height: 26px;
}

.text-title {
    font-size: 30px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #000000;
    line-height: 42px;
}

.btnsList {
    display: flex;
    justify-content: space-around;
    align-items: center;

    //border:1px red solid;
    .btn-child {
        width: 98px;
        height: 32px;
        //background: #CC1F37;
        border-radius: 19px;
        color: white;
        display: flex;
        justify-content: center;
        align-items: center;

        &:last-child {
            margin-left: 32px;
        }
    }
}

.active-btn {
    background: #CC1F37;
}

.texts {
    width: 340px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    text-align: justify;
}

.btns {
    width: 118px;
    height: 42px;
    background: #CC1F37;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 22px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.line {
    border-bottom: 1px #D8D8D8 solid;
    margin-top: 20px;
    margin-bottom: 20px;
}

.btns-box {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .pages {
        color: #333333;
        font-size: 14px;
    }
}

.title-btnsList {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.child-box {
    width: 290px;
    height: 284px;
    background: #FFFFFF;
    border-radius: 0px 16px 0px 16px;
    //border: 1px red solid;
    padding: 31px 24px;
    cursor: pointer;

    .child-top {
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #000000;
        line-height: 28px;
        //padding-bottom: 28px;
        background-position: center center;
        background-size: cover;
        background-repeat: no-repeat;
    }

    .child-date {
        font-size: 14px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #999999;
        line-height: 24px;
        margin-bottom: 10px;
    }

    .child-text {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        text-align: justify;
        margin-bottom: 20px;
    }
}

.mgb40 {
    margin-bottom: 40px;
}

.mgt40 {
    margin-top: 40px;
}

.mgt60 {
    margin-top: 60px;
}

.mgb30 {
    margin-bottom: 30px;
}

.mgb32 {
    margin-bottom: 32px;
}

.mgb100 {
    margin-bottom: 100px;
}

.mgr10 {
    margin-right: 10px;
}

.btn-go {
    width: 32px;
    height: 32px;
    background-color: #CC1F37;
    margin-top: 20px;
}

.default-child {
    width: 2px;
    height: 16%;
    background: rgba(255, 255, 255, 0.1);
}

.active-child {
    background: rgba(54, 169, 255, 0.5);
}

.color36A9FF {
    color: #36A9FF;
}
</style>



// WEBPACK FOOTER //
// src/views/aboutUs.vue